<style lang="scss" src='./Monitor.scss' scoped></style>
<template src="./Monitor.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getZones,
  courseMonitoring,
  taskMonitoring,
  userMonitoring,
  sensorMonitoring,
  iotMonitoring,
  externalMonitoring
} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Monitor',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      refreshDataInterval: null,
      loading: {
        general: false,
        gServices: false,
        tServices: false,
      },
      stickyData: true,
      gServices: [],
      xServices: []
    };
  },
  computed: {
    getGroundworxServices() {
      return this.gServices
    }
  },

  methods: {
    async loadData() {
      this.getGServices();
      this.getXServices();
    },

    async getGServices(){
      if(this.gServices.length == 0){
        this.loading.gServices= true;
      }
      let userStatus = await this.userMonitoring();
      let courseStatus = await this.courseMonitoring();
      let sensorStatus = await this.sensorMonitoring();
      let iotStatus = await this.iotMonitoring();
      let taskStatus = await this.taskMonitoring();

      let services = [
        { 
          name: 'User API',
          status: userStatus.status,
          last_reading: userStatus.time
        },
        { 
          name: 'Golf Course API',
          status: courseStatus.status,
          last_reading: courseStatus.time
        },
        { 
          name: 'Sensor API',
          status: sensorStatus.status,
          last_reading: sensorStatus.time
        },
        { 
          name: 'IoT Dispatcher',
          status: iotStatus.status,
          last_reading: iotStatus.time
        },
        { 
          name: 'Task API',
          status: taskStatus.status,
          last_reading: taskStatus.time
        }
      ];

      this.gServices = services.map(service => ({...service, selected: false}));
      this.loading.gServices = false;
    },

    async userMonitoring() {
      let status = await userMonitoring()
      return {
        status: status ? true : false,
        time: new Date()
      };
    },

    async courseMonitoring() {
      let status = await courseMonitoring()
       return {
        status: status ? true : false,
        time: new Date()
      };
    },

    async sensorMonitoring() {
      let status = await sensorMonitoring()
      return {
        status: status ? true : false,
        time: new Date()
      };
    },

    async iotMonitoring() {
      let status = await iotMonitoring()
       return {
        status: status ? true : false,
        time: new Date()
      };
    },

    async taskMonitoring() {
      let status = await taskMonitoring()
      return {
        status: status ? true : false,
        time: new Date()
      };
    },

    async getXServices() {
      if(this.xServices.length == 0){
        this.loading.xServices= true;
      }

      let data = await externalMonitoring();
      
      if(data){
        this.xServices = data.map(service => ({...service, last_reading: new Date()}))
      }
      this.loading.xServices = false;
    },

    startIntervalToRefreshData() {
      this.refreshDataInterval = window.setInterval(() => {
        this.loadData();
      }, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Monitoring");
      this.$analytics.logEvent("web_settings_monitoring");
    }

    await this.loadData();
    this.startIntervalToRefreshData();
  },

  beforeDestroy() {
    window.clearInterval(this.refreshDataInterval);
  },
};

</script>
